(function () {
  // En-tête collant : la bande bleue du haut disparaît au défilement
  function setTop() {
    var hg = document.getElementById('header-group');
    var tb = document.querySelector('.jd .topbar');
    if (hg && tb) hg.style.setProperty('--jd-top', -tb.offsetHeight + 'px');
  }
  setTop();
  window.addEventListener('resize', setTop);

  document.addEventListener('click', function (e) {
    // Menu déroulant Pâtisseries
    var dd = document.getElementById('jdDd');
    var ddBtn = document.getElementById('jdDdBtn');
    if (dd && ddBtn) {
      if (ddBtn.contains(e.target)) {
        var o = dd.classList.toggle('open');
        ddBtn.setAttribute('aria-expanded', o);
      } else if (!dd.contains(e.target) || e.target.closest('.dd-menu a')) {
        dd.classList.remove('open');
        ddBtn.setAttribute('aria-expanded', false);
      }
    }
    // Menu mobile
    var burger = document.getElementById('jdBurger');
    var mnav = document.getElementById('jdMnav');
    if (burger && mnav) {
      if (burger.contains(e.target)) {
        mnav.hidden = !mnav.hidden;
        burger.setAttribute('aria-expanded', !mnav.hidden);
      } else if (e.target.closest('#jdMnav a')) {
        mnav.hidden = true;
        burger.setAttribute('aria-expanded', false);
      }
    }
  });

  // Ajout au panier sans quitter la page
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.jd .card form, .jd .pcard form');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('.add');
    var icon = btn.classList.contains('pc-add') ? btn.innerHTML : null;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    btn.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw r; return fetch(root + 'cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.jd .cart-count').forEach(function (c) {
          c.textContent = cart.item_count;
          c.classList.add('bump');
          setTimeout(function () { c.classList.remove('bump'); }, 250);
        });
        btn.classList.add('done');
        btn.textContent = icon ? '✓' : 'Ajouté ✓';
        setTimeout(function () { btn.classList.remove('done'); if (icon) { btn.innerHTML = icon; } else { btn.textContent = 'Ajouter'; } btn.disabled = false; }, 1600);
      })
      .catch(function () { btn.disabled = false; form.submit(); });
  });
})();

/* Fiche produit : le client doit choisir lui-même (taille, etc.) avant d'ajouter au panier */
(function () {
  try {
    var f = document.getElementById('jdPForm');
    if (!f) return;
    var sels = f.querySelectorAll('select.jd-opt');
    var add = document.getElementById('jdPAdd');
    if (!sels.length || !add) return;
    if (add.disabled) return; /* produit épuisé : on ne touche à rien */
    var lbl = add.querySelector('.lbl');
    var addText = lbl ? lbl.textContent : '';
    var pr = document.getElementById('jdPPrice');
    var cp = document.getElementById('jdPCompare');
    var hasVariant = false;
    try { hasVariant = new URL(location.href).searchParams.has('variant'); } catch (e) {}

    /* prix affiché avant le choix : « Dès ... » quand les prix diffèrent selon l'option */
    var data = [];
    try { data = JSON.parse(document.getElementById('jdPVariants').textContent); } catch (e) {}
    var num = function (s) { return parseFloat(String(s).replace(/[^\d,.-]/g, '').replace(',', '.')); };
    var startPrice = pr ? pr.textContent : '';
    var seen = {}, distinct = 0;
    data.forEach(function (v) { if (!seen[v.price]) { seen[v.price] = 1; distinct++; } });
    if (distinct > 1) {
      var min = data.reduce(function (a, b) { return num(b.price) < num(a.price) ? b : a; }, data[0]);
      startPrice = 'Dès ' + min.price;
    }

    var label = function (name) {
      var n = (name || '').toLowerCase();
      if (n === 'taille') return 'Choisir une taille';
      if (n === 'format') return 'Choisir un format';
      return 'Choisir : ' + name;
    };

    sels.forEach(function (s) {
      var wrap = s.parentNode;
      var lab = f.querySelector('label[for="' + s.id + '"]');
      var name = lab ? lab.textContent.trim() : '';
      var ph = document.createElement('option');
      ph.value = '';
      ph.textContent = label(name);
      s.insertBefore(ph, s.firstChild);
      s.setAttribute('data-required', '1');
      var err = document.createElement('p');
      err.className = 'p-err';
      err.textContent = name.toLowerCase() === 'taille' ? 'Choisissez une taille.' : 'Merci de faire un choix.';
      wrap.parentNode.insertBefore(err, wrap.nextSibling);
      if (!hasVariant) s.value = '';
      s.addEventListener('change', function () { wrap.classList.toggle('is-missing', !s.value); });
    });

    /* tant que tout n'est pas choisi : bouton actif (le clic est bloqué avec un message), prix « Dès ... » */
    var refresh = function () {
      var empty = false;
      sels.forEach(function (s) { if (!s.value) empty = true; });
      if (!empty) return;
      add.disabled = false;
      if (lbl) lbl.textContent = addText;
      if (pr) pr.textContent = startPrice;
      if (cp) cp.hidden = true;
    };
    sels.forEach(function (s) { s.addEventListener('change', refresh); });
    if (!hasVariant) refresh();
  } catch (err) { /* la fiche reste utilisable même en cas d'erreur */ }
})();
